module.exports = __webpack_public_path__ + "static/media/darkRedCross.5effe877.svg";